module.exports = __webpack_public_path__ + "static/cubeStereo-ff6183ef1d0aea1477de8d785a1fc196.mp4";